import { ReferralCommission } from '/src/lib/models';
import { TResponseMetadata } from '/src/lib/types';

export type TReferralCommissionId = number;

/**
 * Create Referral Commission
 */
export type TCreateReferralCommissionRequest = {
  client_id: number;
  referral_partner_id: number;
  percent_rate: number;
  reporting_period_type_id: number;
  start_reporting_quarter: string;
  end_reporting_quarter: string | null;
};

/**
 * Get Referral Commission
 */
export type TGetReferralCommissionRequest = {
  id: TReferralCommissionId;
};

export type TGetReferralCommissionResponse = ReferralCommission;

/**
 * List Referral Commissions
 */
export type TListReferralCommissionsRequest = {
  limit?: number;
  page?: number;
};

export type TListReferralCommissionsResponse = {
  meta: TResponseMetadata;
  data: ReferralCommission[];
};
